module.exports = __webpack_public_path__ + "assets/img/ab5-8.4d198ec6.png";